import { UIText1 } from '@cian/ui-kit';
import cx from 'clsx';
import * as React from 'react';

import * as style from './style.css';
import { IFeatureItem as IFeaturesItemProps } from '../../../types/offerData';

export const FeaturesItem: React.FC<React.PropsWithChildren<IFeaturesItemProps>> = ({ theme, name }) => {
  return (
    <div className={cx(style['item'], theme && style[theme])}>
      <UIText1>{name}</UIText1>
    </div>
  );
};
